<template>
  <div
    class="trackingContainer viewContainer"
    v-if="!this.$store.state.loading"
    :class="{ navBarActive: $store.state.navBar }"
  >
    <Header
      :loading="loading"
      title="Histórico de Órdenes"
      :showSearch="true"
      searchTitle="Buscar"
      :showFilters="true"
      :showReports="true"
      @filters="filtersDialog = true"
      :showNewButton="false"
      @reports="reportsDialog = true"
    />

    <v-tabs class="mt-5" v-model="tab" centered>
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#1"> Histórico de Órdenes </v-tab>

      <v-tab href="#2"> Links de Pago </v-tab>
    </v-tabs>

    <v-tabs-items class="mt-10" v-model="tab">
      <v-tab-item :value="'1'">
        <tracking-orders :errands="[...scheduledOrders, ...errands]" />
      </v-tab-item>

      <v-tab-item :value="'2'">
        <pay-links :errands="errands" />
      </v-tab-item>
    </v-tabs-items>

    <v-dialog
      width="650"
      persistent
      v-model="filtersDialog"
      v-if="filtersDialog"
    >
      <filters
        :originalStatus="selectedStatus"
        :originalDate="date"
        :tab="tab"
        @cancel="filtersDialog = false"
        @success="applyFilters"
      />
    </v-dialog>

    <v-dialog
      width="550"
      persistent
      v-model="reportsDialog"
      v-if="reportsDialog"
    >
      <Reports
        :tab="tab"
        @cancel="reportsDialog = false"
        @success="reportsDialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import { db, fb } from "@/firebase";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import trackingOrders from "@/components/tracking-orders";

import payLinks from "@/components/tracking-pay-links";
import downloadExcel from "vue-json-excel";
import { mapActions, mapState } from "vuex";
import filters from "@/components/filters";
import Reports from "@/components/Reports";

export default {
  name: "Tracking",
  components: {
    DateRangePicker,
    trackingOrders,
    payLinks,
    downloadExcel,
    filters,
    Reports,
  },
  data() {
    return {
      tab: null,
      loading: true,
      business: null,
      errands: [],
      filtersDialog: false,
      reportsDialog: false,
      date: [
        `${moment()
          .tz("America/Tegucigalpa")
          .subtract(6, "hours")
          .toISOString()
          .substr(0, 10)}`,
        `${moment()
          .tz("America/Tegucigalpa")
          .subtract(6, "hours")
          .toISOString()
          .substr(0, 10)}`,
      ],
      selectedStatus: "",
      tookanPoints: [],
      defaultSchedule: {
        activeFriday: true,
        activeMonday: true,
        activeSaturday: true,
        activeSunday: true,
        activeThursday: true,
        activeTuesday: true,
        activeWednesday: true,
        monday: [
          {
            opensAt: "08:00:00",
            closesAt: "21:00:00",
          },
        ],
        tuesday: [
          {
            opensAt: "08:00:00",
            closesAt: "21:00:00",
          },
        ],
        wednesday: [
          {
            opensAt: "08:00:00",
            closesAt: "21:00:00",
          },
        ],
        thursday: [
          {
            opensAt: "08:00:00",
            closesAt: "21:00:00",
          },
        ],
        friday: [
          {
            opensAt: "08:00:00",
            closesAt: "21:00:00",
          },
        ],
        saturday: [
          {
            opensAt: "08:00:00",
            closesAt: "21:00:00",
          },
        ],
        sunday: [
          {
            opensAt: "08:00:00",
            closesAt: "21:00:00",
          },
        ],
        },
      scheduledOrders: [],
      searchableTagsOrders: [
        { name: "placed", color: "#c0ca33" },
        { name: "accepted", color: "green" },
        { name: "enRoute", color: "#FFBF00" },
        { name: "onDelivery", color: "orange" },
        { name: "delivered", color: "cyan" },
        { name: "completed", color: "blue" },
        { name: "canceled", color: "grey" },
        { name: "rejected", color: "red" },
      ],

      searchableTagsLinks: [
        { name: "paid", color: "green" },
        { name: "pending", color: "gray" },
      ],
    };
  },

  filters: {
    statusFilter: function (status) {
      switch (status) {
        case "scheduled":
          return "Programada";
          break;

        case "paid":
          return "Pagada";
          break;

        case "pending":
          return "Pendiente";
          break;

        case "placed":
          return "Colocada";
          break;

        case "accepted":
          return "Aceptada";
          break;

        case "assigned":
          return "Asignada";
          break;

        case "enRoute":
          return "En Camino";
          break;

        case "enDelivery":
          return "En camino al cliente";
          break;

        case "delivered":
          return "Entregada";
          break;

        case "completed":
          return "Completada";
          break;

        case "canceled":
          return "Cancelada";
          break;

        case "rejected":
          return "Rechazada";
          break;

        case "undeliverable":
          return "No Entregada";
          break;

        default:
          return status;
          break;
      }
    },
    date(data) {
      return data ? moment.utc(data).format("DD/MM/YYYY") : "";
    },
  },
  async mounted() {
    this.$store.commit("setLoading", "Cargando...");
    this.$store.commit("setNavBar", true);
    this.showSearchMobileF(true);

    this.tab = this.$route.params.tab;

    await this.$binding(
      "business",
      db.collection(`businessesCorporative`).doc(this.user.businessID)
    );

    // Validar si existe schedule
    if (!this.business || !this.business.schedule) {
      await db.collection('businessesCorporative').doc(this.user.businessID).update({ schedule: this.defaultSchedule });
    }

    await this.$binding(
      "scheduledOrders",
      db
        .collection(`scheduledOrders`)
        .where("businessId", "==", this.user.businessID)
        .where("state", "==", "placed")
    );

    this.scheduledOrders.forEach((e) => {
      e.source = "scheduled";
    });

    this.filter();
  },
  computed: {
    ...mapState(["searchTerm", "user"]),
    excelName() {
      return `${this.selectedTab == "orders" ? "Envíos" : "Enlaces de pago"}-${
        this.today
      }.xls`;
    },
    today() {
      return new Date().toISOString().substr(0, 10);
    },
    excelFields() {
      if (this.selectedTab == "orders") {
        return {
          Estado: "progressCurrentStatus",
          "ID de Orden": "shortId",
          "Nombre del Negocio": "businessName",
          Cliente: "userName",
          "Teléfono Cliente": "userPhone",
          "Correo Cliente": "userEmail",
          "Conductor Asignado": "deliveryInfo.driverName",
          "Distancia Recorrido (km)": "deliveryDistance",
          "Costo de envío": "deliveryCost",
          "Total de la Orden": "orderTotal",
          "Método de pago": "orderPaymentMethod",
          "Fecha de Creación": "created",
        };
      } else {
        return {
          Estado: "state",
          ID: "code",
          Descripción: "description",
          Monto: "totalProducts",
          Envío: "shipping",
          Total: "total",
          Enlace: "link",
          "Fecha de Creación": "created",
          "Fecha de Vencimiento": "expiration",
        };
      }
    },
  },
  methods: {
    ...mapActions(["showSearch", "showSearchMobileF"]),

    applyFilters(e) {
      this.date = e.date;
      this.selectedStatus = e.selectedStatus;
      this.filtersDialog = false;
      this.filter();
    },
    async filter() {
      this.$store.commit("setLoading", "Cargando...");
      this.loading = true;

      let collection =
        this.tab == "1"
          ? db.collection("ordersErrands")
          : db.collection("paymentLinks");

      let query = collection.where("businessId", "==", this.user.businessID);

      if (this.selectedStatus && this.selectedStatus.length) {
        query =
          this.tab == "1"
            ? query.where("progressCurrentStatus", "in", this.selectedStatus)
            : query.where("state", "in", this.selectedStatus);
      }

      if (this.date[0] && this.date[1] && this.tab == "1") {
        query = query
          .where(
            "progressPlacedAt",
            ">",
            moment(this.date[0], "YYYY-MM-DD").startOf("day").toDate()
          )
          .where(
            "progressPlacedAt",
            "<",
            moment(this.date[1], "YYYY-MM-DD").endOf("day").toDate()
          )
          .orderBy("progressPlacedAt", "desc");
      }

      if (this.tab == "2") {
        query = query.orderBy("createdAt", "desc");
      }

      if (this.date[0] && this.date[1] && this.tab == "2") {
        query = query
          .where(
            "createdAt",
            ">",
            moment(this.date[0], "YYYY-MM-DD").startOf("day").toDate()
          )
          .where(
            "createdAt",
            "<",
            moment(this.date[1], "YYYY-MM-DD").endOf("day").toDate()
          );
      }

      await this.$binding("errands", query);

      // setTimeout(() => {
      //   this.$store.commit("setLoading", "");
      // }, 300);
      this.$store.commit("setLoading", false);
    },
    getColor(status) {
      switch (status) {
        case "placed":
          return "#c0ca33";
          break;

        case "accepted":
          return "#4caf50";
          break;

        case "enRoute":
          return "#FFBF00";
          break;

        case "delivered":
          return "#00bcd4";
          break;

        case "completed":
          return "#2196f3";
          break;

        case "canceled":
          return "grey";
          break;

        case "rejected":
          return "red";
          break;

        default:
          return "gray";
          break;
      }
    },
    async init() {
      await this.$binding(
        "errands",
        db
          .collection(`ordersErrands`)
          .where("businessId", "==", this.user.businessID)
          .where(
            "progressPlacedAt",
            ">",
            moment(this.date[0], "YYYY-MM-DD").startOf("day").toDate()
          )
          .where(
            "progressPlacedAt",
            "<",
            moment(this.date[1], "YYYY-MM-DD").endOf("day").toDate()
          )
          .orderBy("progressPlacedAt", "desc")
      );

      this.$store.commit("setLoading", false);
    },
  },
  watch: {
    tab() {
      this.filter();
    },
    errands() {
      this.errands.forEach(async (item) => {
        let paymentLink = null;

        if (item.paymentLinkId) {
          paymentLink = await db
            .collection("paymentLinks")
            .doc(item.paymentLinkId)
            .get();
          item.paymentLink = paymentLink.data();
        }

        if (item.progressPlacedAt)
          item.created = moment(item.progressPlacedAt.toDate())
            .tz("America/Tegucigalpa")
            .format("LLLL");

        if (item.createdAt)
          item.created = moment(item.createdAt.toDate())
            .tz("America/Tegucigalpa")
            .format("LLLL");

        if (item.code)
          item.link = `https://ocho-pay.web.app/payment/checkout/${item.code}`;

        if (item.expiresAt)
          item.expiration = moment(item.expiresAt.toDate())
            .tz("America/Tegucigalpa")
            .format("LLLL");
      });
    },
  },
};
</script>

<style lang="scss">
.titleContainer {
  h1 {
    font-size: 28px;
    line-height: 28px;
    span {
      font-size: 16px;
      line-height: 16px;
      display: block;
      color: #666;
    }
  }
}
select {
  appearance: none;
  background-color: #b1a4a426;
  border: none;
  padding: 10px;
  margin: 0;
  width: 100%;
  height: 50px;
  border-radius: 20px;
  font-family: inherit;
  font-size: inherit;
  cursor: inherit;
  line-height: inherit;
}

.status-color {
  width: 10px;
  height: 10px;
}

.option {
  padding: 10px;
}

.headers {
  display: grid;
  grid-template-columns: 25% 25% 25% 15% 10%;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  padding-top: 0;
  justify-content: space-between;
}

select:focus,
select:focus {
  outline: none;
}

.filter-btn {
  padding: 15px;
  margin-left: 15px;
  width: 100%;
  cursor: pointer;
  background-color: #FF1744;
  color: white;
  border: none;
  border-radius: 20px;
}

.tab {
  overflow: hidden;
  background-color: transparent;
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.tab button {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
  font-size: 17px;
}

.tab button:hover {
  background-color: #ddd;
}

.tab button.active {
  background-color: #ccc;
}

.tab-active {
  background-color: #cecece !important;
}

.tabcontent {
  display: none;
  padding: 6px 12px;
  border: 1px solid #ccc;
  border-top: none;
}

.excel {
  padding: 10px;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  z-index: 9999;
  cursor: pointer;
  background-color: #646464;

  i {
    color: #ffffff;
    font-size: 20px;
  }
}
</style>

